/* eslint-disable */
import React, { useState, useEffect } from 'react';
import * as Store from '@apply/store';

const OtherEntityOwnerPanel = () => {
    return <div>Owner(s) of Other Entities: In Development</div>;
};

export default OtherEntityOwnerPanel;
